import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPixBold = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.644 6.692c.785 0 1.522.302 2.077.858l3.008 3.007a.554.554 0 0 0 .785 0l3.007-2.995a2.913 2.913 0 0 1 2.077-.858h.363l-3.817-3.816a3.047 3.047 0 0 0-4.3 0L6.04 6.692h.604ZM17.6 17.296a2.913 2.913 0 0 1-2.078-.858l-2.995-2.995a.577.577 0 0 0-.785 0L8.734 16.45a2.914 2.914 0 0 1-2.077.858h-.592l3.804 3.804a3.047 3.047 0 0 0 4.3 0l3.816-3.816h-.386Zm1.207-9.747 2.306 2.307a3.032 3.032 0 0 1 0 4.287l-2.306 2.307a.427.427 0 0 0-.17-.036h-1.05a2.069 2.069 0 0 1-1.45-.604l-2.995-2.995c-.543-.544-1.497-.544-2.04 0l-3.008 3.007a2.027 2.027 0 0 1-1.45.604H5.352a.335.335 0 0 0-.157.036l-2.306-2.307a3.047 3.047 0 0 1 0-4.3l2.319-2.318a.334.334 0 0 0 .157.036h1.292a2.07 2.07 0 0 1 1.45.604l3.006 3.007a1.426 1.426 0 0 0 2.03 0l2.995-2.995a2.027 2.027 0 0 1 1.449-.604h1.05c.06 0 .121-.012.17-.036Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPixBold;
